module.exports = __webpack_public_path__ + "assets/img/select.223b0954.svg";